import styled from "@emotion/styled";
import { Stack } from "@mui/material";

export const NavStack = styled(Stack, {
  shouldForwardProp: prop => prop !== "isOpen",
})`
  display: ${props => (props.isOpen ? "flex" : "none")};
  flex-direction: column;
  margin-right: 0;
  margin-bottom: 100px;

  vertical-align: middle;
  gap: ${p => p.theme.space[3]}px;

  @media (min-width: ${props => props.theme.screenSizes.mdMax}) {
    display: inline-flex;
    align-items: center;
    margin-right: 36px;
    margin-bottom: 0;
    flex-direction: row;
    gap: 16px;
  }

  ${props =>
    props.isOpen &&
    `
    margin-top: 33px;
    z-index: 1;
    left: 0;
    right: 0;
  `}
`;
